import React from "react"
import Carousel from "react-bootstrap/Carousel"

const PromoMessage = () => {
  const promoMessages = [
    {
      href: "/pharmacy-to-pharmacy-marketplace/",
      content: (
        <>
          New:&nbsp;<strong>RPh2RPh - Pharmacy-to-Pharmacy Marketplace!</strong>
        </>
      ),
      className: "p2p",
    },
  ]
  return (
    <>
      <div className="container-promo-message">
        <Carousel interval={10000} indicators={false} fade>
          {promoMessages.map((item, index) => (
            <Carousel.Item key={index}>
              <div className={`banner ${item.className}`}>
                <a rel="noreferrer" href={item.href} target="_blank">
                  {item.content}
                </a>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </>
  )
}

export default PromoMessage
